import routerOptions0 from "/home/jenkins/workspace/Prod_style3d_Front_homesite/node_modules/.pnpm/nuxt@3.3.1_jvuqbdzfigqn2sc5omb2elbuga/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}